import { apiRequest } from "../api/apiClient";

export const getStats = async (timeRange: string, cityName: string) => {
  const params = new URLSearchParams();
  if (timeRange) params.append("timeRange", String(timeRange));
  if (cityName) params.append("city", String(cityName));

  const query = params.toString();
  const { data, error } = await apiRequest("get", `/stats?${query}`);

  return { data, error };
};
